import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CommonModule } from "@angular/common";

@Component({
  selector: 'icon-renderer',
  templateUrl: './icon-renderer.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class IconRendererComponent implements ICellRendererAngularComp {
  /** False greys the icon (`no-active`); it still occupies the cell. */
  public isActive: boolean = true;
  /** True renders nothing at all - for columns whose icon is conditional, e.g. a row chevron. */
  public isHidden: boolean = false;
  icon: string = "";

  constructor() { }

  /**
   * Params (all on `colDef.headerComponentParams`):
   *   `icon`            - the image path, normally an `ICONS.*` constant.
   *   `visibleProperty` - name of a row flag; false greys the icon.
   *   `hideProperty`    - name of a row flag; true omits the icon entirely.
   *   `hideWhenInactive` - omit the icon instead of greying it when `visibleProperty` is false.
   *                       Off by default, so a column that says nothing keeps the greying.
   *
   * A column that configures no flag at all always draws solid. `visibleProperty` is deliberately
   * NOT defaulted to `hasReceipt`, even though that is the field this renderer used to read outright:
   * plenty of rows carry `hasReceipt` incidentally, so an implicit default fades every decorative
   * icon on them - a receipt-less expense would show a greyed-out chevron or eye.
   *
   * That outright read was also defeated by a `this.hasReceipt = true` test stub left in the
   * initialiser, so the greyed state never appeared. Only the eod-template showcase consumed this
   * renderer at the time, so neither removing the stub nor dropping the default can affect a real
   * screen.
   */
  initilize(params: ICellRendererParams) {
    const config: any = params.colDef?.headerComponentParams || {};
    this.icon = config.icon;
    if (params.data) {
      this.isActive = config.visibleProperty ? !!params.data[config.visibleProperty] : true;
      this.isHidden = !!(config.hideProperty && params.data[config.hideProperty])
        || (!this.isActive && !!config.hideWhenInactive);
    } else {
      // Pinned rows carry no data; `@if(icon)` in the template keeps the cell empty.
      this.icon = "";
    }
  }

  agInit(params: any): void {
    this.initilize(params);

  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
